<template>
  <div v-if="post">
    <page-title-header
      v-if="post"
      class="scroll-effect"
      :class="{ 'is-active': isLoaded }"
      :category="post.category"
    ></page-title-header>
    <div class="left-col-container">
      <div class="container">
        <div class="row">
          <div
            class="col-sm-9 left-col-text"
            id="article"
          >
            <div
              v-if="post"
              class="scroll-effect"
              :class="{ 'is-active': isLoaded }"
            >
              <h1>{{ post.title }}</h1>
              <div
                class="article_body"
                v-html="post.bodyHtml"
              ></div>

              <ul
                v-if="post.links"
                class="links"
              >
                <li v-for="link in post.links">
                  <a
                    :href="link.url"
                    target="_blank"
                    >{{ link.label }}</a
                  >
                </li>
              </ul>

              <hr />

              <div v-if="post.tags">
                <h4><span class="glyphicon glyphicon-tags">　</span>タグ</h4>
                <ul class="tags">
                  <li v-for="tag in post.tags">
                    <a :href="`/posts/?tag=${tag.label}`">{{ tag.label }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <side-menu
            v-if="post"
            :category="post.category"
            class="js-scroll-effect scroll-effect"
            data-start-pos="200"
          ></side-menu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EasyScrollEffect from 'easy-scroll-effect'
import str from '@/util/str'
import { Post } from '@/api'
import FbImg from '@/components/atoms/FbImg'
import PageTitleHeader from '@/components/organisms/PageTitleHeader'
import SideMenu from '@/components/organisms/SideMenu'

export default {
  name: 'Post',

  components: {
    FbImg,
    PageTitleHeader,
    SideMenu,
  },

  metaInfo() {
    return {
      title: this.post ? this.post.title : '記事詳細',
      meta: [
        {
          name: 'description',
          content:
            this.post && this.post.bodyText
              ? str.substr(this.post.bodyText.trim(), 150, '...')
              : '',
        },
      ],
    }
  },

  data() {
    return {
      pageName: 'post',
      post: null,
      isLoaded: false,
    }
  },

  computed: {
    postSlug() {
      return this.$route.query.id
    },

    previewToken() {
      return this.$route.query.token
    },
  },

  mounted() {
    EasyScrollEffect.init()
  },

  destroyed() {
    EasyScrollEffect.destroy()
  },

  async created() {
    await this.setPost()
    EasyScrollEffect.init()
    setTimeout(() => {
      this.isLoaded = true
    }, 500)
  },

  methods: {
    async setPost() {
      if (!this.postSlug) return

      this.$store.dispatch('setLoading', true)
      try {
        const params = this.previewToken ? { token: this.previewToken } : null
        const res = await Post.getPosts(this.serviceId, this.postSlug, params)
        this.checkAndRedirectToLinkUrl(res)
        this.post = res
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
      }
    },

    checkAndRedirectToLinkUrl(post) {
      if (!post) return
      if (post.body) return
      if (!post.links) return
      if (post.links.length > 1) return
      if (typeof window === 'undefined') return
      window.location.href = post.links[0].url
    },
  },
}
</script>
